// Keep in sync with benchling/insights/naming_constants.py

export const INSIGHTS_PRODUCT = 'Insights';
